import {useContext} from 'react';

import type {LoggerContextValue} from '../logger/LoggerContext';

import LoggerContext from '../logger/LoggerContext';

export default function useLoggerContext(): LoggerContextValue {
  return useContext(LoggerContext);
}
